import React, { useState } from "react";
import { useCreateThemeDataMutation, useGetThemeDataQuery } from "../../Services/vehicle/Vehicle";
import { capitalizeFirstLetter } from "../../components/reusableComponent/CapitalLetter";
import { toast } from "react-toastify";

const SelectTheme = () => {
    const [selectedColor, setSelectedColor] = useState<any>('')
        const [image, setImage] = useState<any>('')
    
    const colorChoice = ["blue", "purple", "pantone", "orange"];

        const [themeTrigger] = useCreateThemeDataMutation()
               const {data: themeData, refetch} =  useGetThemeDataQuery({})
    
    const changeColorHandler = (color:any) => {
        setSelectedColor(color)
    }

      const imageHandler = (e) => {
        const file = e.target.files[0];
        if (file) {
          setImage(file);
        }
      };

        const submitTheme = async() => {
        const formData = new FormData();
        formData.append("logo", image); // image is a File object from input
        formData.append("selected_theme", selectedColor);
        const response = await themeTrigger(formData)

        try {
            if (response?.data) {
                refetch()
                toast.success("Added successfully")
            }
            
        } catch (error) {
            toast.error("An error occurred")
        }

      }

    return (
        <div>
            <div style={{display: "flex", flexDirection: "column", gap: "20px", marginBottom: "20px"}}>
                <div style={{fontSize: "20px"}}>Select theme color</div>

                <div style={{display: "flex", gap: "10px", justifyContent: "space-between"
                }}>
                    {colorChoice?.map((color) => (
                        <p style={{display: "flex", gap: "5px", alignItems: "center"}}>
                            <span>
                                <input value={selectedColor}  checked={selectedColor === color} type="radio" onChange={() => changeColorHandler(color)}/>
                            </span>
                                <span style={{fontSize: "15px"}}>{capitalizeFirstLetter(color)}</span>
                        </p>
                    ))}
                </div>
            </div>
               <div>
  <p>
    <label htmlFor="upload-logo" style={{
      padding: "8px 12px",
      backgroundColor: "#007bff",
      color: "white",
      borderRadius: "5px",
      cursor: "pointer",
      display: "inline-block",
      marginBottom: "20px"
    }}>
      Upload Logo
    </label>
    <div style={{border: "1px solid black",borderStyle: "dotted", height: "200px", width: "200px"}}>
      {image && 
   
      
      <img src={URL.createObjectURL(image)} alt="preview" width={200}  height={200}/>
    }
    </div>
    <input
      type="file"
      id="upload-logo"
      style={{ display: "none" }}
      onChange={imageHandler}
    />
  </p>

  <button onClick={submitTheme}>Submit</button>


</div>

            <div></div>
        </div>
    );
};

export default SelectTheme;
